import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 42,
	viewBox: "0 0 60 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_dd)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 6,
				y: 3,
				width: 48,
				height: 30,
				rx: 2,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.109 12.2123L20.2306 23.8244H17.0691L14.6922 14.5569C14.6699 14.3381 14.5908 14.129 14.463 13.9502C14.3351 13.7713 14.1628 13.6288 13.963 13.5369C13.0188 13.0893 12.0239 12.7577 11 12.5492L11.0692 12.2123H16.1784C16.513 12.2087 16.8376 12.3264 17.0921 12.5436C17.3466 12.7608 17.5139 13.0628 17.563 13.3938L18.846 20.1137L21.9567 12.2123H25.109ZM37.5703 20.0583C37.5703 16.9938 33.3335 16.8276 33.3612 15.443C33.3612 15.0276 33.7673 14.5846 34.635 14.4738C35.6513 14.3742 36.6755 14.5529 37.598 14.9907L38.1242 12.5261C37.2197 12.1848 36.2618 12.0067 35.295 12C32.3274 12 30.2182 13.5784 30.2182 15.8399C30.2182 17.5107 31.7089 18.4384 32.8443 18.9968C33.9796 19.5553 34.4089 19.9199 34.4042 20.4414C34.4042 21.2214 33.4812 21.5629 32.6089 21.5768C31.5337 21.6015 30.4703 21.3488 29.5212 20.8429L28.9997 23.386C30.0586 23.7989 31.1862 24.0072 32.3227 23.9998C35.475 23.9998 37.5427 22.4445 37.5519 20.0306L37.5703 20.0583ZM45.3979 23.8198H48.1671L45.7441 12.2123H43.178C42.9083 12.2169 42.6458 12.3001 42.4228 12.4518C42.1998 12.6035 42.0259 12.817 41.9226 13.0661L37.395 23.8244H40.538L41.1657 22.0891H45.0195L45.3979 23.8198ZM42.038 19.7076L43.621 15.3507L44.5441 19.7076H42.038ZM29.4012 12.2123L26.9182 23.8244H23.9229L26.4013 12.2123H29.4012Z",
			fill: "#1A1F71"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd",
			x: 0,
			y: 0,
			width: 60,
			height: 42,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1,
					operator: "dilate",
					in: "SourceAlpha",
					result: "effect2_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow",
					result: "effect2_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
